/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "𞤸𞤢𞤲𞤳𞤭",
        "0": "𞤸𞤢𞤲𞤣𞤫",
        "1": "𞤶𞤢𞤲𞤺𞤮",
        "future": {
          "one": "𞤲𞥋𞤣𞤫𞤪 {0} 𞤻𞤢𞤤𞥆𞤢𞤤",
          "other": "𞤲𞥋𞤣𞤫𞤪 {0} 𞤻𞤢𞤤𞥆𞤫"
        },
        "past": {
          "one": "{0} 𞤻𞤢𞤤𞥆𞤢𞤤 𞤱𞤵𞤤𞤭𞥅𞤲𞥋𞤣𞤫",
          "other": "{0} 𞤻𞤢𞤤𞥆𞤫 𞤱𞤵𞤤𞤭𞥅𞤯𞤫"
        }
      },
      "day-narrow": {
        "-1": "𞤸𞤢𞤲𞤳𞤭",
        "0": "𞤸𞤢𞤲𞤣𞤫",
        "1": "𞤶𞤢𞤲𞤺𞤮",
        "future": {
          "one": "𞤲𞥋𞤣𞤫𞤪 {0} 𞤻𞤢𞤤𞥆𞤢𞤤",
          "other": "𞤲𞥋𞤣𞤫𞤪 {0} 𞤻𞤢𞤤𞥆𞤫"
        },
        "past": {
          "one": "{0} 𞤻𞤢𞤤𞥆𞤢𞤤 𞤱𞤵𞤤𞤭𞥅𞤲𞥋𞤣𞤫",
          "other": "{0} 𞤻𞤢𞤤𞥆𞤫 𞤱𞤵𞤤𞤭𞥅𞤯𞤫"
        }
      },
      "day-short": {
        "-1": "𞤸𞤢𞤲𞤳𞤭",
        "0": "𞤸𞤢𞤲𞤣𞤫",
        "1": "𞤶𞤢𞤲𞤺𞤮",
        "future": {
          "one": "𞤲𞥋𞤣𞤫𞤪 {0} 𞤻𞤢𞤤𞥆𞤢𞤤",
          "other": "𞤲𞥋𞤣𞤫𞤪 {0} 𞤻𞤢𞤤𞥆𞤫"
        },
        "past": {
          "one": "{0} 𞤻𞤢𞤤𞥆𞤢𞤤 𞤱𞤵𞤤𞤭𞥅𞤲𞥋𞤣𞤫",
          "other": "{0} 𞤻𞤢𞤤𞥆𞤫 𞤱𞤵𞤤𞤭𞥅𞤯𞤫"
        }
      },
      "hour": {
        "0": "𞤲𞥋𞤣𞤭𞥅 𞤯𞤮𞤮 𞤲𞥋𞤶𞤢𞤥𞤲𞥋𞤣𞤭",
        "future": {
          "one": "𞤲𞥋𞤣𞤫𞤪 {0} 𞤲𞥋𞤶𞤢𞤥𞤲𞥋𞤣𞤭",
          "other": "𞤲𞥋𞤣𞤫𞤪 {0} 𞤲𞥋𞤶𞤢𞤥𞤤𞤭"
        },
        "past": {
          "one": "{0} 𞤲𞥋𞤶𞤢𞤥𞤲𞥋𞤣𞤭 𞤱𞤵𞤤𞤭𞥅𞤲𞥋𞤣𞤭",
          "other": "{0} 𞤲𞥋𞤶𞤢𞤥𞤤𞤭 𞤱𞤵𞤤𞤭𞥅𞤯𞤭"
        }
      },
      "hour-narrow": {
        "0": "𞤐𞤣𞤭𞥅 𞤲𞤶𞤢𞤥𞤲𞤣𞤭",
        "future": {
          "one": "𞤲𞥋𞤣𞤫𞤪 {0} 𞤶𞤢.",
          "other": "𞤲𞥋𞤣𞤫𞤪 {0} 𞤶𞤢."
        },
        "past": {
          "one": "{0} 𞤶𞤢. 𞤱𞤵𞤤𞤭𞥅𞤲𞥋𞤣𞤭",
          "other": "{0} 𞤶𞤢. 𞤱𞤵𞤤𞤭𞥅𞤯𞤭"
        }
      },
      "hour-short": {
        "0": "𞤐𞤣𞤭𞥅 𞤲𞤶𞤢𞤥𞤲𞤣𞤭",
        "future": {
          "one": "𞤲𞥋𞤣𞤫𞤪 {0} 𞤶𞤢.",
          "other": "𞤲𞥋𞤣𞤫𞤪 {0} 𞤶𞤢."
        },
        "past": {
          "one": "{0} 𞤶𞤢. 𞤱𞤵𞤤𞤭𞥅𞤲𞥋𞤣𞤭",
          "other": "{0} 𞤶𞤢. 𞤱𞤵𞤤𞤭𞥅𞤯𞤭"
        }
      },
      "minute": {
        "0": "𞤲𞥋𞤣𞤫𞥅 𞤯𞤮𞤮 𞤸𞤮𞤶𞤮𞤥𞤪𞤫",
        "future": {
          "one": "𞤲𞥋𞤣𞤫𞤪 {0} 𞤸𞤮𞤶𞤮𞤥𞤪𞤫",
          "other": "𞤲𞥋𞤣𞤫𞤪 {0} 𞤳𞤮𞤶𞤮𞤥𞤶𞤫"
        },
        "past": {
          "one": "{0} 𞤸𞤮𞤶𞤮𞤥𞤪𞤫 𞤱𞤵𞤤𞤭𞥅𞤲𞥋𞤣𞤫",
          "other": "{0} 𞤳𞤮𞤶𞤮𞤥𞤶𞤫 𞤱𞤵𞤤𞤭𞥅𞤯𞤫"
        }
      },
      "minute-narrow": {
        "0": "𞤐𞤣𞤫𞥅 𞤸𞤮𞤶𞤮𞤥𞤢𞥄𞤪𞤫",
        "future": {
          "one": "𞤲𞥋𞤣𞤫𞤪 {0} 𞤸𞤮𞤶.",
          "other": "𞤲𞥋𞤣𞤫𞤪 {0} 𞤸𞤮𞤶."
        },
        "past": {
          "one": "{0} 𞤸𞤮𞤶. 𞤱𞤵𞤤𞤭𞥅𞤲𞥋𞤣𞤫",
          "other": "{0} 𞤸𞤮𞤶. 𞤱𞤵𞤤𞤭𞥅𞤯𞤫"
        }
      },
      "minute-short": {
        "0": "𞤲𞤣𞤫𞥅 𞤸𞤮𞤶𞤮𞤥𞤢𞥄𞤪𞤫",
        "future": {
          "one": "𞤲𞥋𞤣𞤫𞤪 {0} 𞤸𞤮𞤶.",
          "other": "𞤲𞥋𞤣𞤫𞤪 {0} 𞤸𞤮𞤶."
        },
        "past": {
          "one": "{0} 𞤸𞤮𞤶. 𞤱𞤵𞤤𞤭𞥅𞤲𞥋𞤣𞤫",
          "other": "{0} 𞤳𞤮𞤶. 𞤱𞤵𞤤𞤭𞥅𞤯𞤫"
        }
      },
      "month": {
        "-1": "𞤤𞤫𞤱𞤪𞤵 𞤬𞤫𞤰𞥆𞤵𞤲𞥋𞤣𞤵",
        "0": "𞤲𞥋𞤣𞤵𞥅 𞤯𞤮𞤮 𞤤𞤫𞤱𞤪𞤵",
        "1": "𞤤𞤫𞤱𞤪𞤵 𞤢𞤪𞤢𞤴𞤲𞥋𞤣𞤵",
        "future": {
          "one": "𞤲𞥋𞤣𞤫𞤪 {0} 𞤤𞤫𞤱𞤪𞤵",
          "other": "𞤲𞥋𞤣𞤫𞤪 {0} 𞤤𞤫𞤦𞥆𞤭"
        },
        "past": {
          "one": "{0} 𞤤𞤫𞤱𞤪𞤵 𞤱𞤵𞤤𞤭𞥅𞤲𞥋𞤣𞤵",
          "other": "{0} 𞤤𞤫𞤦𞥆𞤭 𞤱𞤵𞤤𞤭𞥅𞤯𞤭"
        }
      },
      "month-narrow": {
        "-1": "𞤤𞤫𞤱. 𞤬𞤫𞤰𞥆𞤵𞤲𞥋𞤣𞤵",
        "0": "𞤲𞤣𞤮𞥅 𞤯𞤮𞤮 𞤤𞤫𞤱.",
        "1": "𞤤𞤫𞤱. 𞤸𞤭𞤳𞥆𞤭𞥅𞤲𞤣𞤵",
        "future": {
          "one": "𞤲𞥋𞤣𞤫𞤪 {0} 𞤤𞤫𞤱.",
          "other": "𞤲𞥋𞤣𞤫𞤪 {0} 𞤤𞤫𞤦."
        },
        "past": {
          "one": "{0} 𞤤𞤫𞤱. 𞤱𞤵𞤤𞤭𞥅𞤲𞥋𞤣𞤵",
          "other": "{0} 𞤤𞤫𞤦. 𞤱𞤵𞤤𞤭𞥅𞤯𞤭"
        }
      },
      "month-short": {
        "-1": "𞤤𞤫𞤱. 𞤬𞤫𞤰𞥆𞤵𞤲𞥋𞤣𞤵",
        "0": "𞤲𞤣𞤮𞥅 𞤯𞤮𞤮 𞤤𞤫𞤱.",
        "1": "𞤤𞤫𞤱. 𞤸𞤭𞤳𞥆𞤭𞥅𞤲𞤣𞤵",
        "future": {
          "one": "𞤲𞥋𞤣𞤫𞤪 {0} 𞤤𞤫𞤱.",
          "other": "𞤲𞥋𞤣𞤫𞤪 {0} 𞤤𞤫𞤦."
        },
        "past": {
          "one": "{0} 𞤤𞤫𞤱. 𞤱𞤵𞤤𞤭𞥅𞤲𞥋𞤣𞤵",
          "other": "{0} 𞤤𞤫𞤦. 𞤱𞤵𞤤𞤭𞥅𞤯𞤭"
        }
      },
      "nu": ["adlm"],
      "quarter": {
        "-1": "𞤲𞤢𞤴𞤩𞤭𞥅𞤪𞤫 𞤬𞤫𞤰𞥆𞤵𞤲𞥋𞤣𞤫",
        "0": "𞤲𞤣𞤫𞥅 𞤲𞤢𞤴𞤩𞤭𞥅𞤪𞤫",
        "1": "𞤲𞤢𞤴𞤩𞤭𞥅𞤪𞤫 𞤢𞤪𞤮𞥅𞤪𞤫",
        "future": {
          "one": "𞤲𞤣𞤫𞤪 𞤲𞤢𞤴𞤩𞤭𞥅𞤪𞤫 {0}",
          "other": "𞤲𞤣𞤫𞤪 𞤲𞤢𞤴𞤩𞤭𞥅𞤶𞤫 {0}"
        },
        "past": {
          "one": "𞤱𞤢𞤯𞤭𞥅 𞤲𞤢𞤴𞤩𞤭𞥅𞤪𞤫 {0}",
          "other": "{0} 𞤲𞤢𞤴𞤢𞤩𞤭𞥅𞤶𞤫 𞤱𞤵𞤤𞤭𞥅𞤯𞤫"
        }
      },
      "quarter-narrow": {
        "-1": "𞤲𞤢𞤴. 𞤬𞤫𞤰.",
        "0": "𞤲𞤣𞤫𞥅 𞤲𞤢𞤴.",
        "1": "𞤲𞤢𞤴. 𞤢𞤪𞤮𞥅𞤪𞤫",
        "future": {
          "one": "𞤲𞤣𞤫𞤪 𞤲𞤢𞤴. {0}",
          "other": "𞤲𞤣𞤫𞤪 𞤲𞤢𞤴. {0}"
        },
        "past": {
          "one": "{0} 𞤲𞤢𞤴. 𞤱𞤵𞤤𞤭𞥅𞤲𞥋𞤣𞤫",
          "other": "{0} 𞤲𞤢𞤴𞤶. 𞤱𞤵𞤤𞤭𞥅𞤲𞥋𞤣𞤫"
        }
      },
      "quarter-short": {
        "-1": "𞤲𞤢𞤴. 𞤬𞤫𞤰.",
        "0": "𞤲𞤣𞤫𞥅 𞤲𞤢𞤴.",
        "1": "𞤲𞤢𞤴. 𞤢𞤪𞤮𞥅𞤪𞤫",
        "future": {
          "one": "𞤲𞤣𞤫𞤪 𞤲𞤢𞤴. {0}",
          "other": "𞤲𞤣𞤫𞤪 𞤲𞤢𞤴. {0}"
        },
        "past": {
          "one": "𞤱𞤢𞤯𞤭𞥅 𞤲𞤢𞤴. {0}",
          "other": "{0} 𞤲𞤢𞤴𞤶. 𞤱𞤵𞤤𞤭𞥅𞤯𞤫"
        }
      },
      "second": {
        "0": "𞤶𞤮𞥅𞤲𞤭",
        "future": {
          "one": "𞤲𞥋𞤣𞤫𞤪 {0} 𞤳𞤭𞤲𞤰𞤢𞤤",
          "other": "𞤲𞥋𞤣𞤫𞤪 {0} 𞤳𞤭𞤲𞤰𞤫"
        },
        "past": {
          "one": "{0} 𞤳𞤭𞤲𞤰𞤢𞤤 𞤱𞤵𞤤𞤭𞥅𞤲𞥋𞤺𞤢𞤤",
          "other": "{0} 𞤳𞤭𞤲𞤰𞤫 𞤱𞤵𞤤𞤭𞥅𞤯𞤫"
        }
      },
      "second-narrow": {
        "0": "𞤶𞤮𞥅𞤲𞤭",
        "future": {
          "one": "𞤲𞥋𞤣𞤫𞤪 {0} 𞤳𞤭𞤲.",
          "other": "𞤲𞥋𞤣𞤫𞤪 {0} 𞤳𞤭𞤲."
        },
        "past": {
          "one": "{0} 𞤳𞤭𞤲. 𞤱𞤵𞤤𞤭𞥅𞤲𞥋𞤺𞤢𞤤",
          "other": "{0} 𞤳𞤭𞤲. 𞤱𞤵𞤤𞤭𞥅𞤯𞤫"
        }
      },
      "second-short": {
        "0": "𞤶𞤮𞥅𞤲𞤭",
        "future": {
          "one": "𞤲𞥋𞤣𞤫𞤪 {0} 𞤳𞤭𞤲.",
          "other": "𞤲𞥋𞤣𞤫𞤪 {0} 𞤳𞤭𞤲."
        },
        "past": {
          "one": "{0} 𞤳𞤭𞤲. 𞤱𞤵𞤤𞤭𞥅𞤲𞥋𞤺𞤢𞤤",
          "other": "{0} 𞤳𞤭𞤲. 𞤱𞤵𞤤𞤭𞥅𞤯𞤫"
        }
      },
      "week": {
        "-1": "𞤴𞤮𞤲𞤼𞤫𞤪𞤫 𞤬𞤫𞤰𞥆𞤵𞤲𞥋𞤣𞤫",
        "0": "𞤲𞤣𞤫𞥅 𞤯𞤮𞤮 𞤴𞤮𞤲𞤼𞤫𞤪𞤫",
        "1": "𞤴𞤮𞤲𞤼𞤫𞤪𞤫 𞤢𞤪𞤢𞤴𞤲𞤣𞤫",
        "future": {
          "one": "𞤲𞥋𞤣𞤫𞤪 {0} 𞤴𞤮𞤲𞤼𞤫𞤪𞤫",
          "other": "𞤲𞥋𞤣𞤫𞤪 {0} 𞤶𞤮𞤲𞤼𞤫"
        },
        "past": {
          "one": "{0} 𞤴𞤮𞤲𞤼𞤫𞤪𞤫 𞤱𞤵𞤤𞤭𞥅𞤲𞥋𞤣𞤫",
          "other": "{0} 𞤶𞤮𞤲𞤼𞤫 𞤱𞤵𞤤𞤭𞥅𞤯𞤫"
        }
      },
      "week-narrow": {
        "-1": "𞤴𞤼. 𞤬𞤫𞤰𞥆𞤵𞤲𞥋𞤣𞤫",
        "0": "𞤲𞤣𞤫𞥅 𞤯𞤮𞤮 𞤴𞤼.",
        "1": "𞤴𞤼. 𞤸𞤭𞤳𞥆𞤭𞥅𞤲𞤣𞤫",
        "future": {
          "one": "𞤲𞥋𞤣𞤫𞤪 {0} 𞤴𞤼.",
          "other": "𞤲𞥋𞤣𞤫𞤪 {0} 𞤶𞤼."
        },
        "past": {
          "one": "{0} 𞤴𞤼. 𞤱𞤵𞤤𞤭𞥅𞤲𞥋𞤣𞤫",
          "other": "{0} 𞤶𞤼. 𞤱𞤵𞤤𞤭𞥅𞤯𞤫"
        }
      },
      "week-short": {
        "-1": "𞤴𞤼. 𞤬𞤫𞤰𞥆𞤵𞤲𞥋𞤣𞤫",
        "0": "𞤲𞤣𞤫𞥅 𞤯𞤮𞤮 𞤴𞤼.",
        "1": "𞤴𞤼. 𞤸𞤭𞤳𞥆𞤭𞥅𞤲𞤣𞤫",
        "future": {
          "one": "𞤲𞥋𞤣𞤫𞤪 {0} 𞤴𞤼.",
          "other": "𞤲𞥋𞤣𞤫𞤪 {0} 𞤶𞤼."
        },
        "past": {
          "one": "{0} 𞤴𞤼. 𞤱𞤵𞤤𞤭𞥅𞤲𞥋𞤣𞤫",
          "other": "{0} 𞤶𞤼. 𞤱𞤵𞤤𞤭𞥅𞤯𞤫"
        }
      },
      "year": {
        "-1": "𞤪𞤮𞤱𞤢𞤲𞤭",
        "0": "𞤸𞤭𞤳𞥆𞤢",
        "1": "𞤸𞤭𞤼𞤢𞥄𞤲𞤣𞤫 𞤢𞤪𞤮𞥅𞤪𞤫",
        "future": {
          "one": "𞤲𞤣𞤫𞤪 {0} 𞤸𞤭𞤼𞤢𞥄𞤲𞤣𞤫",
          "other": "𞤲𞤣𞤫𞤪 {0} 𞤳𞤭𞤼𞤢𞥄𞤤𞤫"
        },
        "past": {
          "one": "𞤱𞤢𞤯𞤭𞥅 𞤸𞤭𞤼𞤢𞥄𞤲𞤣𞤫 {0}",
          "other": "{0} 𞤳𞤭𞤼𞤢𞥄𞤯𞤫 𞤪𞤫𞤱𞤢𞤲𞤭"
        }
      },
      "year-narrow": {
        "-1": "𞤪𞤮𞤱𞤢𞤲𞤭",
        "0": "𞤸𞤭𞤳𞥆𞤢",
        "1": "𞤸𞤭𞤼 𞤢𞤪𞤮𞥅𞤪𞤫",
        "future": {
          "one": "𞤲𞤣𞤫𞤪 𞤸𞤭𞤼. {0}",
          "other": "𞤲𞤣𞤫𞤪 𞤳𞤭𞤼. {0}"
        },
        "past": {
          "one": "{0} 𞤸𞤭𞤼. 𞤪𞤫𞤱𞤢𞤲𞤭",
          "other": "{0} 𞤳𞤭𞤼. 𞤪𞤫𞤱𞤢𞤲𞤭"
        }
      },
      "year-short": {
        "-1": "𞤪𞤮𞤱𞤢𞤲𞤭",
        "0": "𞤸𞤭𞤳𞥆𞤢",
        "1": "𞤸𞤭𞤼𞤢𞥄𞤲𞤣𞤫 𞤢𞤪𞤮𞥅𞤪𞤫",
        "future": {
          "one": "𞤲𞤣𞤫𞤪 𞤸𞤭𞤼. {0}",
          "other": "𞤲𞤣𞤫𞤪 𞤳𞤭𞤼. {0}"
        },
        "past": {
          "one": "{0} 𞤸𞤭𞤼. 𞤪𞤫𞤱𞤢𞤲𞤭",
          "other": "{0} 𞤳𞤭𞤼. 𞤪𞤫𞤱𞤢𞤲𞤭"
        }
      }
    },
    "locale": "ff-Adlm-GM"
  });
}